import { SimpleGrid } from 'src/design/atoms/SimpleGrid';
import { Title } from 'src/design/atoms/Title';
import React from 'react';
import { Header } from 'src/design/organisms/Header';
import { SafetyFormCard } from 'src/routes/Safety/components/SafetyFormCard';

const PROACTEHS_BASE_URL = 'https://app.proactehs.com/dashboard/forms/user';

/**
 * Static configuration schema for safety forms.
 * Each form has a formId, name, and optional description.
 * The URL is constructed using the formId.
 */
export interface ISafetyFormConfig {
  formId: string;
  name: string;
  description?: string;
}

/**
 * Constructs the full URL for a safety form.
 */
const buildFormUrl = (formId: string): string =>
  `${PROACTEHS_BASE_URL}/${formId}/submit?headless=true`;

/**
 * Static configuration of safety forms.
 * Add new forms here as needed.
 */
const SAFETY_FORMS: ISafetyFormConfig[] = [
  { formId: '531', name: 'Vehicle Incident' },
  { formId: '529', name: 'Employee Injury' },
  { formId: '528', name: 'Property Damage' },
];

const MISC_SAFETY_FORMS: ISafetyFormConfig[] = [
  { formId: '516', name: 'Body Harness and Lanyard Inspection Report' },
  { formId: '488', name: 'Elevated Work HA and Risk Mitigation Plan' },
  { formId: '489', name: 'Field Safety Checklist' },
  { formId: '515', name: 'Job Safety Analysis (JSA)' },
  { formId: '513', name: 'Ladder Pre-Use Inspection Checklist' },
  { formId: '514', name: 'Monthly Vehicle Checklist' },
  { formId: '486', name: 'Near-Miss Report' },
  { formId: '588', name: 'SOP Hangar Check List' },
];

export const Safety: React.FC = () => {
  return (
    <>
      <Header
        title="Safety"
        helpText="Access safety forms and resources for your organization."
        breadcrumbProps={{
          items: [{ text: 'Safety' }],
        }}
      />

      <SimpleGrid cols={{ base: 1, md: 3 }}>
        {SAFETY_FORMS.map((form) => (
          <SafetyFormCard
            key={form.formId}
            name={form.name}
            description={form.description}
            url={buildFormUrl(form.formId)}
            highlighted
          />
        ))}
      </SimpleGrid>

      <Title order={4} mt="xl" mb="sm">
        Misc
      </Title>

      <SimpleGrid cols={{ base: 1, md: 3, lg: 4 }}>
        {MISC_SAFETY_FORMS.map((form) => (
          <SafetyFormCard
            key={form.formId}
            name={form.name}
            description={form.description}
            url={buildFormUrl(form.formId)}
          />
        ))}
      </SimpleGrid>
    </>
  );
};
